var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"id":"Ellipse_12","data-name":"Ellipse 12","cx":"24","cy":"24","r":"24","fill":"#e62a2c","key":0}),React.createElement("path",{"id":"Icon_awesome-youtube","data-name":"Icon awesome-youtube","d":"M29.309,7.675a3.627,3.627,0,0,0-2.552-2.568C24.506,4.5,15.481,4.5,15.481,4.5S6.456,4.5,4.2,5.107A3.627,3.627,0,0,0,1.653,7.675a38.044,38.044,0,0,0-.6,6.992,38.044,38.044,0,0,0,.6,6.992A3.573,3.573,0,0,0,4.2,24.187c2.251.607,11.276.607,11.276.607s9.025,0,11.276-.607a3.573,3.573,0,0,0,2.552-2.527,38.044,38.044,0,0,0,.6-6.992,38.044,38.044,0,0,0-.6-6.992ZM12.529,18.959V10.376l7.543,4.292-7.543,4.291Z","transform":"translate(8.949 9.5)","fill":"#fff","key":1})]);
}

Youtube.defaultProps = {"id":"Youtube","viewBox":"0 0 48 48"};

module.exports = Youtube;

Youtube.default = Youtube;
